import * as React from 'react';

import { cn } from '@/lib/utils';

const SectionHeader = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'text-center text-h3 font-black text-title sm:text-header md:text-h2',
      className
    )}
    {...props}
  />
));
SectionHeader.displayName = 'SectionHeader';

export { SectionHeader };
